import { makeStyles } from '@material-ui/core';

export const vendaFormaPagamentoStyles = makeStyles({
  title: {
    fontSize: 19,
    fontWeight: 500,
    marginBottom: 8,
  },
  divider: {
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
    marginBottom: 16,
  },
  diferencaParcelas: {
    fontSize: 15,
    fontWeight: 500,
    '&.erro': {
      color: '#f00',
    },
  },
  buttonAdicionarEmail: {
    color: '#53c4e6',
    fontSize: 15,
    marginTop: 8,
  },
});
